var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.authLayout)?_c('AppHeader'):_vm._e(),(!_vm.authLayout)?_c('AppSidebar'):_vm._e(),_c('div',{class:{ app__wrapper: !_vm.authLayout }},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),(_vm.loading)?_c('UiSpinnerLoading'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }